<div
  novaCard
  variant="primary"
  class="rcm-summary__card"
  [ngClass]="'rcm-summary__card--' + card.accent"
  *ngFor="let card of cards; trackBy: trackByKey"
>
  <div novaCardContent>
    <div class="rcm-summary__top">
      <nova-icon
        class="rcm-summary__icon"
        [name]="card.iconName"
        [size]="20"
      ></nova-icon>
      <span class="rcm-summary__count" [attr.data-testid]="card.key + '-count'">
        {{ card.value }}
      </span>
    </div>
    <h2 class="rcm-summary__label">{{ card.label }}</h2>
    <p class="rcm-summary__sublabel">{{ card.sublabel }}</p>
  </div>
</div>
